var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygonLime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.466917 3.93562C-0.0720123 1.68999 2.02213 -0.296949 4.23637 0.359143L10.8791 2.32742C13.0933 2.98351 13.767 5.79056 12.0917 7.3801L7.06576 12.1487C5.39044 13.7383 2.62263 12.9182 2.0837 10.6725L0.466917 3.93562Z",
    fill: "#A6EC9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonLime);
export default __webpack_public_path__ + "static/media/polygon-lime.f45ec495486305480f21c91e96c1da99.svg";
export { ForwardRef as ReactComponent };